<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <a
              href="#"
              @click.prevent="activeReport =''"
            >
              {{ $t('myCabinetMenu.hesabatlar') }}
            </a>
          </li>
        </ol>
      </div>

      <h3 class="my-3">
        {{ $t('myCabinetMenu.hesabatlar') }}
      </h3>
    </div>


    <div v-if="activeReport===''">
      <div class="row">
        <div class="col-md-6 col-12 mb-3">
          <div
            class="card h-100 mb-0 pointer"
            @click.prevent="activeReport = 'dynamics'"
          >
            <div class="card-body">
              <h6 class="f-w-600">
                {{ $t('vendorManagementRequestDynamicsReport.soruVTkliflrinDinamikas') }}
              </h6>
              <p>{{ $t('vendorManagementReports.seilmiMddtRzindYaradlmSorularVAlnanTkliflr') }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <div
            class="card h-100 mb-0 pointer"
            @click.prevent="activeReport = 'purchases'"
          >
            <div class="card-body">
              <h6 class="f-w-600">
                {{ $t('vendorManagementPurchasesReports.alHesabat') }}
              </h6>
              <p>{{ $t('vendorManagementReports.seilmiMddtRzindHyataKeirilmiAllar') }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <div
            class="card h-100 mb-0 pointer"
            @click.prevent="activeReport = 'requests'"
          >
            <div class="card-body">
              <h6 class="f-w-600">
                {{ $t('soruHesabat') }}
              </h6>
              <p>{{ $t('vendorManagementReports.seilmiMddtTamamlanmSorularnHesabat') }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <div
            class="card h-100 mb-0 pointer"
            @click.prevent="activeReport = 'vendors'"
          >
            <div class="card-body">
              <h6 class="f-w-600">
                {{ $t('vendorManagementReports.tdarkHesabat') }}
              </h6>
              <p>{{ $t('vendorManagementReports.tsdiqlnmiTdarkVMracitHesabat') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div
          v-if="activeReport==='dynamics'"
          class="col-12"
        >
          <VendorManagementRequestDynamicsReports />
        </div>
        <div
          v-if="activeReport==='purchases'"
          class="col-12"
        >
          <VendorManagementPurchasesReports />
        </div>
        <div
          v-if="activeReport==='requests'"
          class="col-12"
        >
          <VendorManagementRequestStatusReport />
        </div>
        <div
          v-else-if="activeReport==='vendors'"
          class="col-12"
        >
          <VendorManagementVendorRequestReport :sector-vendor-statistics="sectorVendorStatistics" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import VendorManagementRequestDynamicsReports
  from "@/pages/scc/vendorManagement/reports/VendorManagementRequestDynamicsReports.vue";
import VendorManagementPurchasesReports from "@/pages/scc/vendorManagement/reports/VendorManagementPurchasesReports.vue";
import VendorManagementRequestStatusReport from "@/pages/scc/vendorManagement/reports/VendorManagementRequestStatusReport.vue";
import VendorManagementVendorRequestReport from "@/pages/scc/vendorManagement/reports/VendorManagementVendorRequestReport.vue";

export default {
  components: {
    VendorManagementVendorRequestReport,
    VendorManagementRequestStatusReport,
    VendorManagementPurchasesReports,
    VendorManagementRequestDynamicsReports,

  },
  data() {
    return {
      mediaBase: mediaBase,
      sectorVendorStatistics: [],
      activeReport: ''
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


  },
  mounted() {


  },
  methods: {}

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
